import React from 'react';
import {Row, Col} from 'react-bootstrap';

const EmptyRow = () => {
    return (
        <>
            <Row>
                <Col lg={12}>
                    &nbsp;
                </Col>
            </Row>
        </>
    );
}

export default EmptyRow;
